import { Injectable, signal, computed, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { ErrorHandlerService } from './error-handler.service';
import { ITenant } from '../interfaces/tenant.interface';
import { fetchWithAuth } from '../utils/fetchWithAuth';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  private env = environment;
  private _errorHandler = inject(ErrorHandlerService);

  tenants = signal<ITenant[]>([]);
  searchQuery = signal<string>('');

  filteredTenants = computed(() => {
    const searchTerm = this.searchQuery().toLowerCase().trim();
    if (!searchTerm) return this.tenants(); // Return all if no search term

    return this.tenants().filter(
      (tenant) =>
        tenant.name.toLowerCase().includes(searchTerm) ||
        tenant.subdomain.toLowerCase().includes(searchTerm)
    );
  });

  async fetchTenants(): Promise<void> {
    try {
      const response = await fetchWithAuth(`${this.env.API_URL}/tenants`, {
        method: 'GET',
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (!response.ok) {
        this._errorHandler.handleError(data.message);
        return;
      }

      const processedData = data.map((tenant: any) => ({
        ...tenant,
        logo_url: tenant.logo_url?.startsWith('/edu-public/')
          ? `https://s3.maxbrain.com${tenant.logo_url}`
          : tenant.logo_url || 'assets/maxbrain-logo.svg',
      }));

      this.tenants.set(processedData);
    } catch (error: any) {
      this._errorHandler.handleError(error.message);
      this.tenants.set([]);
    }
  }

  setSearchQuery(query: string) {
    this.searchQuery.set(query);
  }
}
